import { Array as RunTypesArray, Boolean, Literal, Record, String, Union, Number } from "runtypes";
import { Reason } from "../../../types/error";
import { OcspResponderRevocationReason, RevocationStatus, RevocationStatusArray, ValidRevocationStatus, ValidRevocationStatusArray, } from "../revocation.types";
/**
 * DID signed issuance status
 */
export const ValidDidSignedIssuanceStatus = Record({
    did: String,
    issued: Literal(true),
});
export const ValidDidSignedIssuanceStatusArray = RunTypesArray(ValidDidSignedIssuanceStatus);
export const InvalidDidSignedIssuanceStatus = Record({
    did: String,
    issued: Literal(false),
    reason: Reason,
});
export const DidSignedIssuanceStatus = Union(ValidDidSignedIssuanceStatus, InvalidDidSignedIssuanceStatus);
export const DidSignedIssuanceStatusArray = RunTypesArray(DidSignedIssuanceStatus);
/**
 * OCSP response
 */
export const ValidOcspReasonCode = Number.withConstraint((n) => Object.values(OcspResponderRevocationReason).includes(n));
export const ValidOcspResponse = Record({
    revoked: Literal(false),
    documentHash: String,
});
export const ValidOcspResponseRevoked = Record({
    revoked: Literal(true),
    documentHash: String,
    reasonCode: ValidOcspReasonCode,
});
/**
 * Data for v2 Fragments
 */
export const ValidDidSignedDataV2 = Record({
    issuedOnAll: Literal(true),
    revokedOnAny: Literal(false),
    details: Record({
        issuance: ValidDidSignedIssuanceStatusArray,
        revocation: ValidRevocationStatusArray,
    }),
});
export const InvalidDidSignedDataV2 = Record({
    issuedOnAll: Boolean,
    revokedOnAny: Boolean,
    details: Record({
        issuance: DidSignedIssuanceStatusArray,
        revocation: RevocationStatusArray,
    }),
});
/**
 * Data for v3 Fragments
 */
export const ValidDidSignedDataV3 = Record({
    issuedOnAll: Literal(true),
    revokedOnAny: Literal(false),
    details: Record({
        issuance: ValidDidSignedIssuanceStatus,
        revocation: ValidRevocationStatus,
    }),
});
export const InvalidDidSignedDataV3 = Record({
    issuedOnAll: Boolean,
    revokedOnAny: Boolean,
    details: Record({
        issuance: DidSignedIssuanceStatus,
        revocation: RevocationStatus,
    }),
});
